import styled from 'styled-components'

export const NameCell = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['6'],
}))

export const NameTextGroup = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
}))

export const PermissionsCell = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
}))

export const PermissionRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['6'],
}))

export const RowText = styled.div({
  minWidth: 0,
  width: 'fit-content',
})

export const DateTimeCell = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['2'],
}))

export const IconBadge = styled.div<{ $bgColor: string }>(({ $bgColor }) => ({
  alignItems: 'center',
  backgroundColor: $bgColor,
  borderRadius: '50%',
  display: 'flex',
  flexShrink: 0,
  height: '2rem',
  justifyContent: 'center',
  width: '2rem',
}))
